import React from 'react';
import { MdClose, MdFullscreen, MdFullscreenExit } from 'react-icons/md';

export interface IframeControlsProps {
  isExpanded: boolean;
  isFullscreen: boolean;
  onToggleExpand: () => void;
  onClose: () => void;
  className?: string;
}

export function IframeControls({
  isExpanded,
  isFullscreen,
  onToggleExpand,
  onClose,
  className = '',
}: IframeControlsProps) {
  if (isFullscreen) return null;
  
  return (
    <div className={`absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 z-20 flex flex-col gap-2 ${className}`}>
      <button
        onClick={onToggleExpand}
        className="p-2 bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200"
        aria-label={isExpanded ? "Collapse widget panel" : "Expand widget panel"}
        title={isExpanded ? "Collapse widget panel" : "Expand widget panel"}
      >
        {isExpanded ? (
          <MdFullscreenExit className="w-5 h-5 text-gray-600" />
        ) : (
          <MdFullscreen className="w-5 h-5 text-gray-600" />
        )}
      </button>
      <button
        onClick={onClose}
        className="p-2 bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200"
        aria-label="Close widget panel"
        title="Close widget panel"
      >
        <MdClose className="w-5 h-5 text-gray-600" />
      </button>
    </div>
  );
}

